import { EmailCampaignAPI } from 'api'

export const getCampaignByID = async id => {
  return EmailCampaignAPI.get(`/email_campaign/${id}`)
}

export const getPeopleInCampaign = async (id, params) => (
  EmailCampaignAPI.get(`/reporting/people_in_campaign_reports/${id}`, { params })
)

export const unenrollUser = async (payload) => (
  EmailCampaignAPI.post(`/unenroll/manual`, payload)
)

export const getEmailCampaignReport = async (id, datesObj) => (
  EmailCampaignAPI.get(`/reporting/campaign_reports/${id}`, {
    params: datesObj
  })
)
